export const showLoadingIndicator = 'SHOW_LOADER_INDICATOR';
export const hideLoadingIndicator = 'HIDE_LOADER_INDICATOR';